export default __webpack_public_path__ + "static/media/dokomi.25925e81.png";